import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/constantes";
import { RootState } from "@store/store";
import { RevisandoExpedienteProcesando } from "@pages/producto/credito_simple/revision_expediente/RevisionExpedienteProcesando";
import { RevisionExpedientePasos } from "@pages/producto/credito_simple/revision_expediente/RevisionExpedientePasos";
import { RevisionExpedienteResumen } from "@pages/producto/credito_simple/revision_expediente/RevisionExpedienteResumen";
/**
 * Despacha a la pantalla de revisión correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de procesamiento genérica.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.MERCADER_PM]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE]: RevisionExpedientePasos,
  [TAX_SYSTEMS_CODES.FLUX_PM]: RevisionExpedienteResumen,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: RevisionExpedienteResumen,
};

export const RevisionExpediente = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || RevisandoExpedienteProcesando;
  return <Screen />;
};
